import { postWithAuth } from "./apiHelpers";
import config from "../config";

export const migrateChildrenToClassroom = async (classroomId, childIds, token) => {
    return await Promise.all(
        childIds.map(async (childId) => {
            try {
                await postWithAuth(
                    `${config.apiBaseUrl}/child-classrooms/assign`,
                    null,
                    token,
                    {
                        childId,
                        classroomId,
                        setCurrent: false,
                    }
                );
                return { childId, success: true };
            } catch (error) {
                const reason = error.response?.data?.message || error.message || "Unknown error";
                return { childId, success: false, reason };
            }
        })
    );
};